import React, { useState } from 'react'

import CloseDialogIconButton from 'src/components/iconbutton/CloseDialogIconButton.js'
import FreightBookingTranslationText from 'src/views/freightbooking/shared/FreightBookingTranslationText'
import Paper from '@material-ui/core/Paper'
import VesselSearchDialogContext from './VesselSearchDialogContext.js'
import VesselSearchForm from './VesselSearchForm.js'
import { components } from 'cng-web-lib'

const { CngDialog } = components

function VesselSearchDialog({
  isDialogOpen,
  closeDialog,
  showNotification,
  booking
}) {
  const [isSubmitting, setSubmitting] = useState(false)
  const translatedTextsObject = FreightBookingTranslationText()

  return (
    <VesselSearchDialogContext.Provider
      value={{
        closeDialog,
        showNotification,
        form: {
          isSubmitting,
          setSubmitting
        }
      }}
    >
      <CngDialog
        customDialogContent={
          <Paper>
            <VesselSearchForm booking={booking}
              closeDialog={closeDialog} />
          </Paper>
        }
        dialogTitle={
          <>
            <b>{translatedTextsObject.vesselSearch}</b>
            <CloseDialogIconButton
              onClick={closeDialog}
              disabled={isSubmitting}
            />
          </>
        }
        open={isDialogOpen}
        fullWidth
        maxWidth='xl'
      />
    </VesselSearchDialogContext.Provider>
  )
}

export default VesselSearchDialog
